import React from 'react';
import { ShowIf, validatable } from 'components/utils';
import { ContainerFileDinhKem } from 'components/upload';
import { Link } from 'react-router';
import { TextMessage, Text } from 'components/tt-forms/common';
import { ThanhTra } from 'api';
require('./style.scss');
class DoiTuongKienNghiView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataDetail: {},
      id: this.props.id,

      linhVucThanhTra: this.props.linhVucThanhTra,
      listDoiTuongViPham: this.props.listDoiTuongViPham,
      chucNangCuocThanhTra: this.props.chucNangCuocThanhTra,
    }
  }

  componentDidMount() {
    this.getChiTietDoiTuongTraThanhTra(this.state.id)
  }

  getChiTietDoiTuongTraThanhTra(id) {
    ThanhTra.actions.getChiTietDoiTuongTraThanhTra.request({ id: id }).then(res => {
      if (res.data) {
        let Data = res.data;
        this.setState({
          dataDetail: Data,
        })
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      linhVucThanhTra: nextProps.linhVucThanhTra,
    })
  }

  closeDialog() {
    this.props.closeDialog();
  }

  render() {
    let Data = this.state.dataDetail;
    return (
      <section className="wrap-dtkn">
        <div className='content-dtkn'>
          <div className='wrap-items-content'>
            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb5'>1. Tên của đối tượng</h2>
              <Text className='col-50 mb10' value={Data.ten ? Data.ten : ''} />
            </div>

            <div className='col-100 pb15'><div className='line-border'></div></div>

            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb10'>2. Thu hồi trong quá trình thanh tra</h2>
              <ShowIf condition={this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH'}>
                <div>
                  <Text className='col-25 mb10' label='Đã thu tiền (đ):' value={Data.tienDaThuTrongQuaTrinhThanhTra ? Data.tienDaThuTrongQuaTrinhThanhTra : ''} />
                  <Text className='col-25 mb10' label='Đã thu đất (m2):' value={Data.datDaThuTrongQuaTrinhThanhTra ? Data.datDaThuTrongQuaTrinhThanhTra : ''} />
                </div>
              </ShowIf>
              <ShowIf condition={this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH'}>
                <div>
                  <Text className='col-25 mb10' label='Tổng số (đ):' value={Data.tongSoTienThuHoiTrongQuaTrinhThanhTra ? Data.tongSoTienThuHoiTrongQuaTrinhThanhTra : ''} />
                  <Text className='col-25 mb10' label='Cá nhân (đ):' value={Data.caNhanTienThuHoiTrongQuaTrinhThanhTra ? Data.caNhanTienThuHoiTrongQuaTrinhThanhTra : ''} />
                  <Text className='col-25 mb10' label='Tổ chức (đ):' value={Data.toChucTienThuHoiTrongQuaTrinhThanhTra ? Data.toChucTienThuHoiTrongQuaTrinhThanhTra : ''} />
                </div>
              </ShowIf>
            </div>

            <ShowIf condition={this.state.linhVucThanhTra.includes('DAT_DAI')}>
              <div>
                <div className='col-100 pb15'><div className='line-border'></div></div>
                <h2 className='title-14 col-100 mb10'>3. Kiến nghị xử lý đất</h2>

                <Text className='col-25 mb10' label='Đất lấn chiếm (m2):' value={Data.datLanChiemKienNghiXuLyVeDat ? Data.datLanChiemKienNghiXuLyVeDat : ''} />
                <Text className='col-25 mb10' label='Giao, cấp đất sai đối tượng QĐ (m2):' value={Data.giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat ? Data.giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat : ''} />
                <Text className='col-25 mb10' label='Cấp, bán đất trái thẩm quyền (m2):' value={Data.capBanDatTraiThamQuyenKienNghiXuLyVeDat ? Data.capBanDatTraiThamQuyenKienNghiXuLyVeDat : ''} />
                <Text className='col-25 mb10' label='Cấp GCNQSD đất sai (m2):' value={Data.capGCNQSDDatSaiKienNghiXuLyVeDat ? Data.capGCNQSDDatSaiKienNghiXuLyVeDat : ''} />
                <Text className='col-25 mb10' label='CN, cho thuê không đúng QĐ (m2):' value={Data.cNChoThueKhongDungQDKienNghiXuLyVeDat ? Data.cNChoThueKhongDungQDKienNghiXuLyVeDat : ''} />
                <Text className='col-25 mb10' label='SD đất không đúng MĐ, sai QĐ (m2):' value={Data.sDDatKhongDungMDKienNghiXuLyVeDat ? Data.sDDatKhongDungMDKienNghiXuLyVeDat : ''} />
                <Text className='col-25 mb10' label='Bỏ hoang hóa (m2):' value={Data.boHoanHoaKienNghiXuLyVeDat ? Data.boHoanHoaKienNghiXuLyVeDat : ''} />
                <Text className='col-25 mb10' label='Sai phạm khác (m2):' value={Data.saiPhamKhacKienNghiXuLyVeDat ? Data.saiPhamKhacKienNghiXuLyVeDat : ''} />

              </div>
            </ShowIf>

            <div className='col-100 pb15'><div className='line-border'></div></div>

            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb10'>{this.state.linhVucThanhTra.includes('DAT_DAI') ? '4. Kiến nghị xử lý về hành chính' : '3. Kiến nghị xử lý về hành chính'}</h2>
              <Text className='col-100 mb10' label='Tổ chức có sai phạm:' value={Data.toChucCoSaiPham ? Data.toChucCoSaiPham : ''} />
              <Text className='col-25 mb10' label='Hình thức kiến nghị:' value={Data.hinhThucKienNghiToChuc ? Data.hinhThucKienNghiToChuc : ''} />
              <Text className='col-100 mb10' label='Cá nhân có sai phạm:' value={Data.caNhanCoSaiPham ? Data.caNhanCoSaiPham : ''} />
              <Text className='col-25 mb10' label='Hình thức kiến nghị:' value={Data.hinhThucKienNghiCaNhan ? Data.hinhThucKienNghiCaNhan : ''} />
            </div>

            <div className='col-100 pb15'><div className='line-border'></div></div>

            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb15'>{this.state.linhVucThanhTra.includes('DAT_DAI') ? '5. Kiến nghị xử lý về kinh tế' : '4. Kiến nghị xử lý về kinh tế'}</h2>
              <ShowIf condition={this.state.linhVucThanhTra.includes('DAT_DAI')}>
                <div className='col-100 no-gutter'>
                  <h2 className='txt-bold txt-upper col-100 mb10'>Kiến nghị thu hồi</h2>
                  <Text className='col-25 mb10' label='Sai phạm về tiền (đ):' value={Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Sai phạm về đất (m2):' value={Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Quyết định giao đất:' value={Data.quyetDinhGiaoDat ? Data.quyetDinhGiaoDat : ''} />
                </div>
                <div className='col-100 no-gutter'>
                  <h2 className='txt-bold txt-upper col-100 mb10'>Kiến nghị khác</h2>
                  <Text className='col-25 mb10' label='Sai phạm về tiền (đ):' value={Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Sai phạm về đất (m2):' value={Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe : ''} />
                </div>
              </ShowIf>
              <ShowIf condition={this.state.linhVucThanhTra.includes('XAY_DUNG_CO_BAN')}>
                <div className='col-50 no-gutter'>
                  <h2 className='txt-bold txt-upper col-100 mb10'>Kiến nghị thu hồi</h2>
                  <Text className='col-50 mb10' label='Sai phạm về tiền (đ):' value={Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : ''} />
                  <Text className='col-50 mb10' label='Sai phạm về đất (m2):' value={Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : ''} />
                </div>
                <div className='col-50 no-gutter'>
                  <h2 className='txt-bold txt-upper col-100 mb10'>Kiến nghị khác</h2>
                  <Text className='col-50 mb10' label='Sai phạm về tiền (đ):' value={Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe : ''} />
                  <Text className='col-50 mb10' label='Sai phạm về đất (m2):' value={Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe : ''} />
                </div>
              </ShowIf>
              <ShowIf condition={this.state.linhVucThanhTra.includes('TAI_CHINH') || this.state.linhVucThanhTra.includes('THANH_TRA_TRACH_NHIEM')}>
                <div className='col-100 no-gutter'>
                  <h2 className='txt-bold txt-upper col-100 mb10'>Kiến nghị thu hồi</h2>
                  <Text className='col-25 mb10' label='Sai phạm về tiền (đ):' value={Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Sai phạm về đất (m2):' value={Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : ''} />
                </div>
              </ShowIf>
              <ShowIf condition={this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH'}>
                <div className='col-100 no-gutter'>
                  <h2 className='txt-bold txt-upper col-100 mb10'>Số tiền vi phạm</h2>
                  <Text className='col-25 mb10' label='Tổng số (đ):' value={Data.tongSoTienViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienViPhamKienNghiXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Cá nhân (đ):' value={Data.tienCaNhanViPhamKienNghiXuLyVeKinhTe ? Data.tienCaNhanViPhamKienNghiXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Tổ chức (đ):' value={Data.tienToChucViPhamKienNghiXuLyVeKinhTe ? Data.tienToChucViPhamKienNghiXuLyVeKinhTe : ''} />
                </div>
                <div className='col-100 no-gutter'>
                  <h2 className='txt-bold txt-upper col-100 mb5'>Số tiền kiến nghị thu hồi (đ)</h2>
                  <Text className='col-25 mb10' label={null} value={Data.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe : ''} />
                </div>
                <div className='col-100 no-gutter'>
                  <h2 className='txt-bold txt-upper col-100 mb10'>Số tiền xử lý tài sản vi phạm</h2>
                  <Text className='col-25 mb10' label='Tổng số (đ):' value={Data.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Tịch thu (đ):' value={Data.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Tiêu hủy (đ):' value={Data.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : ''} />
                </div>
                <div className='col-100 no-gutter'>
                  <h2 className='txt-bold txt-upper col-100 mb10'>Số tiền xử phạt vi phạm</h2>
                  <Text className='col-25 mb10' label='Tổng số (đ):' value={Data.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Cá nhân (đ):' value={Data.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Tổ chức (đ):' value={Data.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe : ''} />
                </div>
                <TextMessage className='col-100 mb10' label='Sai phạm khác:' value={Data.saiPhamKhac ? Data.saiPhamKhac : ''} />

              </ShowIf>
              <ShowIf condition={this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH'}>
                <h2 className='txt-bold txt-upper col-100 mb5'>Sai phạm khác</h2>
                <TextMessage className='col-100 mb10' label={null} value={Data.saiPhamKhac ? Data.saiPhamKhac : ''} />
              </ShowIf>
            </div>

            <div className='col-100 pb15'><div className='line-border'></div></div>

            <ShowIf condition={this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH'}>

              <div className='col-100 no-gutter'>
                <h2 className='title-14 col-100 mb10'>{this.state.linhVucThanhTra.includes('DAT_DAI') ? '6. Kiến nghị chuyển cơ quan điều tra' : '5. Kiến nghị chuyển cơ quan điều tra'}</h2>
                <Text className='col-25 mb10' label='Số vụ việc:' value={Data.soVuViecKienNghiChuyenCoQuanDieuTra ? Data.soVuViecKienNghiChuyenCoQuanDieuTra : ''} />
                <ShowIf condition={Data.chuyenCoQuanDieuTra}>
                  <div className='wrap-showif-check col-100 no-gutterer'>
                    <h2 className='title-attach mb15 col-100'>Chuyển cơ quan điều tra</h2>
                    <div className='col-100 no-gutter'>
                      <Text className='col-25 mb10' label='Số quyết định:' value={Data.soQuyetDinhChuyenCoQuanDieuTra ? Data.soQuyetDinhChuyenCoQuanDieuTra : ''} />
                      <Text className='col-25 mb10' label='Người ra quyết định:' value={Data.nguoiRaQuyetDinhChuyenCoQuanDieuTra ? Data.nguoiRaQuyetDinhChuyenCoQuanDieuTra : ''} />
                    </div>
                    <div className='col-100 no-gutter'>
                      <Text className='col-50' label='Tên cơ quan:' value={Data.coQuanDieuTraThanhTraInfo ? Data.coQuanDieuTraThanhTraInfo.text : ''} />
                      <ShowIf condition={Data.coQuanDieuTraThanhTra == 'KHAC'}>
                        <Text className='col-25 mb10' label='Cơ quan điều tra khác:' value={Data.coQuanDieuTraKhac ? Data.coQuanDieuTraKhac : ''} />
                      </ShowIf>
                      <Text className='col-25 mb10' label='Số vụ' value={Data.soVuChuyenCoQuanDieuTra ? Data.soVuChuyenCoQuanDieuTra : ''} />
                    </div>
                    <ShowIf condition={true}>
                      <div className='col-100'>
                        <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} disableAttachFile={true} dataShow={Data.listTaiLieuVanThuChuyenCoQuanDieuTra ? Data.listTaiLieuVanThuChuyenCoQuanDieuTra : []} />
                      </div>
                    </ShowIf>
                  </div>
                </ShowIf>
              </div>

              <div className='col-100 pb15'><div className='line-border'></div></div>
            </ShowIf>

            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb10'>{this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH' ? (this.state.linhVucThanhTra.includes('DAT_DAI') ? '7. Kiến nghị xử lý khác' : '6. Kiến nghị xử lý khác') : '5. Kiến nghị xử lý khác'}</h2>
              <Text className='col-25 mb10' label='Kiến nghị tiền (đ)' value={Data.tienKienNghiXuLyKhac ? Data.tienKienNghiXuLyKhac : ''} />
              <ShowIf condition={this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH'}>
                <Text className='col-25 mb10' label='Kiến nghị đất (m2)' value={Data.datKienNghiXuLyKhac ? Data.datKienNghiXuLyKhac : ''} />
                <TextMessage className='col-100 mb10' label='Nội dung kiến nghị khác' value={Data.noiDungKienNghiXuLyKhac ? Data.noiDungKienNghiXuLyKhac : ''} />
              </ShowIf>
              <ShowIf condition={true}>
                <div className='col-100'>
                  <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} disableAttachFile={true} dataShow={Data.listTaiLieuVanThuKienNghiXuLyKhac ? Data.listTaiLieuVanThuKienNghiXuLyKhac : []} />
                </div>
              </ShowIf>
            </div>
            <div className="col-100 no-gutter pt15 pb5">
              <div className="box-bottom">
                <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this)}><span>Đóng</span></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

DoiTuongKienNghiView.defaultProps = {
  validators: {
    formTaoDon: []
  },
  linhVucThanhTra: [],
  listDoiTuongViPham: []
}

export default validatable(DoiTuongKienNghiView);


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/sub-view/DoiTuongKienNghiView.jsx